import { Component } from '@angular/core';

@Component({
  selector: 'app-radio-button-showcase',
  templateUrl: './radio-button-showcase.component.html',
  styleUrls: ['./radio-button-showcase.component.scss']
})
export class RadioButtonShowcaseComponent {
  basicChecked = false;
  disabledUnchecked = false;
  disabledChecked = true;
  errorSelected = false;
  smallSelected = false;
  mediumSelected = true;
  largeSelected = false;
  options = [false, false, false];

  onBasicChange(value: boolean): void {
    this.basicChecked = value;
  }

  onSizeChange(index: number, value: boolean): void {
    this.options[index] = value;
  }
}
